module.exports = __webpack_public_path__ + "static/media/Check.1d8aaf2a.svg";